module.exports = __webpack_public_path__ + "img/img34.4dd6780a.svg";